/* eslint-disable @typescript-eslint/naming-convention */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Environment, setEnvironment } from '@ov-suite/helpers-shared/lib/environments/environment';
import * as Sentry from '@sentry/angular';
import { BrowserTracing } from '@sentry/tracing';
import { AppModule } from './app/app.module';
import '@angular/compiler';

fetch('/assets/config.json', {
  method: 'GET',
})
  .then(response => {
    if (response.ok) {
      return response.json();
    }
    return Promise.reject(response);
  })
  // .then((data: Environment) => {
  //   if (data.sentryUrl) {
  //     return axios
  //       .get(data.sentryUrl)
  //       .then(res => {
  //         data.hasSentry = true;
  //         return data;
  //       })
  //       .catch(err => {
  //         data.hasSentry = false;
  //         return data;
  //       });
  //   }
  //   data.hasSentry = false;
  //   return data;
  // })
  .then((data: Environment) => {
    localStorage.setItem('config', JSON.stringify(data));

    if (data.production) {
      enableProdMode();
    }
    setEnvironment(data);
    return data;
  })
  .then(data => {
    if (data.sentryUrl) {
      Sentry.init({
        dsn: data.sentryUrl,
        integrations: [
          // @ts-ignore
          new BrowserTracing({
            tracingOrigins: ['localhost'],
            routingInstrumentation: Sentry.routingInstrumentation,
          }),
        ],

        release: `${data.location}-idmlink`,
        environment: data.envName,
        tracesSampleRate: 1.0,
      });
    }
  })
  .then(() => {
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  })
  .catch(error => {
    console.warn('Something went wrong.', error);
    throw error;
  });
